module.exports = __webpack_public_path__ + "img/combination.6735c0bb.svg";